import React from 'react';
import MultiCategoryDisplay from '../layout/MainBestilLayout/MultiCategoryDisplay';
import { Paragraph, LinkStyled } from '../../../components/typography';


export default () => (
  <React.Fragment>
    <MultiCategoryDisplay page="FlaskerOgDaaser" subPage="Kildevand" />
    <Paragraph paddingBottom="0px" paddingTop="10px">
      Priserne er <LinkStyled to="/bestil/returpant">uden pant</LinkStyled>
    </Paragraph>
  </React.Fragment>
);
